import JobSearch from './JobSearch.container';

export default JobSearch;
